import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { memo } from "react";

const MapRender = ({ selected, onSelect }) => {
  const mapStyles = {
    position: "relative",
    height: "330px",
    width: "100%",
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
  });

  const handleMapLoad = (map) => {
    map.addListener("zoom_changed", () => {
      const zoom = map.getZoom();
      onSelect((old) => ({ place: old?.place, zoom }));
    });
  };

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap
      zoom={selected?.zoom}
      onLoad={handleMapLoad}
      center={selected?.place}
      mapContainerStyle={mapStyles}
      onClick={(e) => {
        const place = { lat: e.latLng?.lat(), lng: e.latLng?.lng() };
        onSelect((old) => ({ zoom: old?.zoom, place }));
      }}
    >
      {selected?.place && <Marker position={selected?.place} />}
    </GoogleMap>
  );
};

export default memo(MapRender);
